var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoForHeroSection1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 417,
    height: 417,
    viewBox: "0 0 417 417",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M417 0V417H1.52588e-05V238.28H59.5735V357.427H357.427V0H417Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M297 0V59.0143H59.4029V177H1.52588e-05V0H297Z",
    fill: "#00A44F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.99 179V237.986H297V297H120V120H297V179H178.99Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoForHeroSection1);
export default __webpack_public_path__ + "static/media/logoForHeroSection1.0a7f757031c3c5f88241b26f4ba7af91.svg";
export { ForwardRef as ReactComponent };